module.exports = __webpack_public_path__ + "static/media/webinar-redirect.d507e95c.svg";